function createFontFace(fontSData) {
    if (fontSData) {
        return Object.keys(fontSData).map((font) => {
            return `@font-face {\nfont-family: '${font}';\nsrc: url(${fontSData[font]});\n}`
        }).join('\n')
    }
}
export default createFontFace;